import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { FrontEndService } from "../../services/front-end.service";

@Component({
    selector: 'app-forbidden',
    templateUrl: './forbidden.component.html',
    styleUrls: ['./forbidden.component.scss']
})
export class ForbiddenComponent {

    constructor(
        private translate: TranslateService,
        private _location: Location,
        public front_end_service: FrontEndService
    ) { }
}
